import { Type } from 'class-transformer';

import { ApiProperty } from '../codegen';
import {
  IsDateString,
  IsEnum,
  IsNumber,
  IsOptional,
  IsString,
  ValidateNested,
} from '../validators';

import { EAccountUpdateType } from './EAccountUpdateType';

/**
 * Enum for notification types that can be sent via SSE.
 */
export enum ENotificationType {
  achievement = 'achievement',
  rematch = 'rematch',
}

/**
 * Payload for achievement notifications.
 */
export class NotificationAchievementPayloadDto {
  @ApiProperty()
  @IsNumber({}, { groups: ['error'] })
  achievementId: number;

  @ApiProperty()
  @IsString({ groups: ['error'] })
  achievementName: string;

  @ApiProperty()
  @IsNumber({}, { groups: ['error'] })
  coins: number;
}

/**
 * Payload for rematch request notifications.
 * Contains all identifiers needed for accept/decline operations.
 */
export class NotificationRematchPayloadDto {
  @ApiProperty()
  @IsString({ groups: ['error'] })
  rematchRequestId: string;

  @ApiProperty()
  @IsNumber({}, { groups: ['error'] })
  fromUserId: number;

  @ApiProperty()
  @IsString({ groups: ['error'] })
  fromUsername: string;

  @ApiProperty()
  @IsNumber({}, { groups: ['error'] })
  gameId: number;

  @ApiProperty()
  @IsString({ groups: ['error'] })
  gameName: string;
}

/**
 * Union type for all notification payloads.
 */
export type TNotificationPayload =
  | NotificationAchievementPayloadDto
  | NotificationRematchPayloadDto;

/**
 * Base notification SSE DTO sent to clients.
 */
export class AccountSSENotificationDto {
  @ApiProperty()
  @IsEnum(EAccountUpdateType, { groups: ['error'] })
  updateType: EAccountUpdateType.notification;

  @ApiProperty()
  @IsString({ groups: ['error'] })
  notificationId: string;

  @ApiProperty()
  @IsEnum(ENotificationType, { groups: ['error'] })
  type: ENotificationType;

  @ApiProperty()
  @IsString({ groups: ['error'] })
  message: string;

  @ApiProperty()
  @IsDateString(undefined, { groups: ['error'] })
  createdAt: string;

  @ApiProperty()
  @IsOptional()
  @IsDateString(undefined, { groups: ['error'] })
  expiresAt?: string;

  @ApiProperty()
  @ValidateNested({ groups: ['error'] })
  @Type(() => NotificationAchievementPayloadDto)
  payload: TNotificationPayload;
}
